var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaboratoryDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0EFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4430_18994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 34C48.5 27.7507 43.416 22.6667 37.1667 22.6667H33.8334C33.8334 20.928 32.7187 19.4467 31.1667 18.896V17.3333C31.1667 16.5973 30.5707 16 29.8334 16C29.096 16 28.5 16.5973 28.5 17.3333V18.896C26.948 19.4467 25.8334 20.928 25.8334 22.6667V33.3333C25.8334 34.0693 26.4294 34.6667 27.1667 34.6667H32.5C33.2374 34.6667 33.8334 34.0693 33.8334 33.3333V25.3333H37.1667C41.9454 25.3333 45.8334 29.2213 45.8334 34C45.8334 38.7787 41.9454 42.6667 37.1667 42.6667H31.1667V40H36.5C37.2374 40 37.8334 39.4027 37.8334 38.6667C37.8334 37.9307 37.2374 37.3333 36.5 37.3333H23.1667C22.4294 37.3333 21.8334 37.9307 21.8334 38.6667C21.8334 39.4027 22.4294 40 23.1667 40H28.5V42.6667H19.1667C18.4294 42.6667 17.8334 43.264 17.8334 44C17.8334 44.736 18.4294 45.3333 19.1667 45.3333H20.5V46.6667C20.5 47.4027 21.096 48 21.8334 48C22.5707 48 23.1667 47.4027 23.1667 46.6667V45.3333H36.5V46.6667C36.5 47.4027 37.096 48 37.8334 48C38.5707 48 39.1667 47.4027 39.1667 46.6667V45.156C44.4654 44.208 48.5 39.5667 48.5 34ZM31.1667 32H28.5V22.6667C28.5 21.932 29.0974 21.3333 29.8334 21.3333C30.5694 21.3333 31.1667 21.932 31.1667 22.6667V32Z",
    fill: "#6158FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4430_18994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratoryDefault);
export default __webpack_public_path__ + "static/media/laboratory-default.8373dc7955f2650f583c6edd4eb43bd7.svg";
export { ForwardRef as ReactComponent };